import { Lozingsvorm, Relatie } from '@/lib/types/relatie';

type DischargeReport = Partial<Pick<Relatie, 'registratiejaar' | 'teeltwijze' | 'lozingsVorm' | 'lozingen'>>;

export function sanitizeLozingen(relatie: DischargeReport) {
  const year = Number(relatie.registratiejaar);
  const isV4Lozing = year >= 2027;
  const behoudenGrondteelt = (teeltwijze: number | undefined) => year >= 2026 && teeltwijze === 0;
  const gebruiktRiool = (teeltwijze: number | undefined, vorm: number) =>
    teeltwijze === 1 && [Lozingsvorm.Riool, Lozingsvorm.RioolEnOppervlaktewater].includes(vorm);
  const gebruiktOppervlaktewater = (teeltwijze: number | undefined, vorm: number) =>
    teeltwijze === 0 ||
    [Lozingsvorm.GeenLozing, Lozingsvorm.Oppervlaktewater, Lozingsvorm.RioolEnOppervlaktewater, Lozingsvorm.Bodem, Lozingsvorm.GeenDrainagesysteem].includes(
      vorm
    );
  const maakNulLozingen = (teeltwijze: number, vorm: number) =>
    Array.from({ length: 13 }, (_, index) => ({
      periode: index + 1,
      ...(isV4Lozing
        ? {
            ...(gebruiktRiool(teeltwijze, vorm) ? { hoeveelheidRiool: 0 } : {}),
            ...(gebruiktOppervlaktewater(teeltwijze, vorm) ? { hoeveelheidOppervlaktewater: 0 } : {}),
          }
        : { hoeveelheid: 0 }),
    }));

  if (!relatie.lozingen) {
    return {
      lozingen: (relatie.lozingsVorm || [])
        .filter(vorm => !behoudenGrondteelt(vorm.betrekkingTotTeeltwijze))
        .map(vorm => ({
          betrekkingTotTeeltwijze: vorm.betrekkingTotTeeltwijze,
          lozingen: maakNulLozingen(vorm.betrekkingTotTeeltwijze, vorm.value),
        })),
    };
  }

  const geldigeTeeltwijzen = relatie.teeltwijze === 2 ? [0, 1] : [relatie.teeltwijze];
  let lozingen = relatie.lozingen
    .filter(group => geldigeTeeltwijzen.includes(group?.betrekkingTotTeeltwijze ?? -1))
    .filter((group, index, all) => all.findIndex(item => item.betrekkingTotTeeltwijze === group.betrekkingTotTeeltwijze) === index)
    .map(group => {
      const vorm = relatie.lozingsVorm?.find(item => item.betrekkingTotTeeltwijze === group.betrekkingTotTeeltwijze)?.value;
      return {
        ...group,
        lozingen: group.lozingen.map(row => {
          const { hoeveelheid, hoeveelheidRiool, hoeveelheidOppervlaktewater, ...overigeVelden } = row;
          if (!isV4Lozing) return { ...overigeVelden, hoeveelheid };
          return {
            ...overigeVelden,
            ...(gebruiktRiool(group.betrekkingTotTeeltwijze, vorm ?? -1) ? { hoeveelheidRiool } : {}),
            ...(gebruiktOppervlaktewater(group.betrekkingTotTeeltwijze, vorm ?? -1) ? { hoeveelheidOppervlaktewater } : {}),
          };
        }),
      };
    });

  (relatie.lozingsVorm || []).forEach(vorm => {
    if (
      !behoudenGrondteelt(vorm.betrekkingTotTeeltwijze) &&
      [Lozingsvorm.GeenLozing, Lozingsvorm.Bodem, Lozingsvorm.GeenDrainagesysteem].includes(vorm.value)
    ) {
      lozingen = lozingen.filter(group => group.betrekkingTotTeeltwijze !== vorm.betrekkingTotTeeltwijze);
      lozingen.push({ betrekkingTotTeeltwijze: vorm.betrekkingTotTeeltwijze, lozingen: maakNulLozingen(vorm.betrekkingTotTeeltwijze, vorm.value) });
    }
  });
  return { lozingen };
}
